import { Component, OnInit, Input } from '@angular/core';
import { ApiWebHook, Settings } from '../../model/settings.model';
import { FormControl, FormGroup } from '@angular/forms';
import { ParametersService } from '../../service/parameters.service';
import { stringify } from '@angular/compiler/src/util';
const parse: typeof Parse = require('parse');
import { ToastService } from '../../service/toast.service';
import { SelectPossibleOption } from '../../model/search';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'app-parameters-apiwebhook',
  templateUrl: './parameters-apiwebhook.component.html',
  styleUrls: ['./parameters-apiwebhook.component.less']
})
export class ParametersApiwebhookComponent implements OnInit {

  @Input() apiWebHook: ApiWebHook;

  isLoadingPublic: boolean;
  isLoadingPrivate: boolean;
  isLoading: boolean;
  hidePrivate: boolean;
  hidePublic: boolean;
  publicKey: string;
  privateKey: string;
  webhookForm: FormGroup;
  timerEvent: NodeJS.Timer;
  newValueSelectTestOption: string;

  typeValue: SelectPossibleOption[];

  constructor(private readonly _parametersService: ParametersService,
    private readonly i18n: I18n,
    private readonly _toastService: ToastService) {

    this.hidePrivate = true;
    this.hidePublic = true;
    this.isLoading = true;
    this.isLoadingPublic = false;
    this.isLoadingPrivate = false;
    this.typeValue = [
      {
        key: 'newTchek', value: this.i18n({
          id: "newTchek",
          value: "Nouveau tchek",
          description: "Nouveau tchek",
          meaning: "apiWebhook"
        })
      },
      {
        key: 'detectionFinished', value: this.i18n({
          id: "endOfDetection",
          value: 'Detection terminée',
          description: 'Detection terminée',
          meaning: "apiWebhook"
        })
      },
      {
        key: 'detectionFinishedCloud', value: this.i18n({
          id: "endOfDetectionCloud",
          value: 'Detection terminée (Cloud)',
          description: 'Detection terminée (Cloud)',
          meaning: "apiWebhook"
        })
      },
      {
        key: 'sendToSI', value: this.i18n({
          id: "notifyIf",
          value: 'Notifier SI',
          description: 'Notifier SI',
          meaning: "apiWebhook"
        })
      },
      {
        key: 'createPDF', value: this.i18n({
          id: "makePdf",
          value: 'Création du PDF',
          description: 'Création du PDF',
          meaning: "apiWebhook"
        })
      },
      {
        key: 'createPDFCloud', value: this.i18n({
          id: "makePdfCloud",
          value: 'Création du PDF (Cloud)',
          description: 'Création du PDF (Cloud)',
          meaning: "apiWebhook"
        })
      },
    ];
    this.newValueSelectTestOption = 'newTchek';
    this.webhookForm = new FormGroup({
      webhook: new FormControl(''),
      headerKey: new FormControl(''),
      newTchek: new FormControl(false),
      detectionFinished: new FormControl(false),
      detectionFinishedCloud: new FormControl(false),
      sendToSI: new FormControl(false),
      croppedImages: new FormControl(true),
      multiplePictureDamage: new FormControl(false),
      webhookPdf: new FormControl(true),
      webhookPdfCloud: new FormControl(true),
    });

  }

  ngOnInit() {
    this.privateKey = this.hide(this.hidePrivate, this.apiWebHook.privateKey);
    this.publicKey = this.hide(this.hidePublic, this.apiWebHook.publicKey);

    this.webhookForm.setValue({
      webhook: this.apiWebHook.webhook !== undefined ? this.apiWebHook.webhook : '',
      headerKey: this.apiWebHook.headerKey !== undefined ? this.apiWebHook.headerKey : '',
      newTchek: this.apiWebHook.options.newTchek !== undefined ? this.apiWebHook.options.newTchek : false,
      detectionFinished: this.apiWebHook.options.detectionFinished !== undefined ? this.apiWebHook.options.detectionFinished : false,
      detectionFinishedCloud: this.apiWebHook.options.detectionFinishedCloud !== undefined ? this.apiWebHook.options.detectionFinishedCloud : false,
      sendToSI: this.apiWebHook.options.sendToSI !== undefined ? this.apiWebHook.options.sendToSI : false,
      croppedImages: this.apiWebHook.options.croppedImages !== undefined ? this.apiWebHook.options.croppedImages : true,
      multiplePictureDamage: this.apiWebHook.options.multiplePictureDamage !== undefined ? this.apiWebHook.options.multiplePictureDamage : false,
      webhookPdf: this.apiWebHook.options.webhookPdf !== undefined ? this.apiWebHook.options.webhookPdf : true,
      webhookPdfCloud: this.apiWebHook.options.webhookPdfCloud !== undefined ? this.apiWebHook.options.webhookPdfCloud : true
    });

    this.webhookForm.valueChanges.subscribe((newValues) => {
      this.apiWebHook.webhook = newValues.webhook
      this.apiWebHook.headerKey = newValues.headerKey
      this.apiWebHook.options = {
        croppedImages: newValues.croppedImages,
        multiplePictureDamage: newValues.multiplePictureDamage,
        webhookPdf: newValues.webhookPdf,
        webhookPdfCloud: newValues.webhookPdfCloud,
        newTchek: newValues.newTchek,
        detectionFinished: newValues.detectionFinished,
        detectionFinishedCloud: newValues.detectionFinishedCloud,
        sendToSI: newValues.sendToSI
      };
      this.sendWebhook();
    });

    this.isLoading = false;
  }

  sendWebhook() {
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      this._toastService.toastOpen(true);
      this._parametersService.savewebhook({
        webhook: this.apiWebHook.webhook,
        headerKey: this.apiWebHook.headerKey,
        options: this.apiWebHook.options
      }).then((saved: Settings) => {
        this.apiWebHook = saved.api;
        this._toastService.toastOpen(false);
      });
    }, 500);
  }

  newtoken(type: string) {
    if (type === 'private')
      this.isLoadingPrivate = true;
    else if (type === 'public')
      this.isLoadingPublic = true;

    this._parametersService.asknewtoken(type)
      .then((result) => {
        if (result.type === 'private') {
          this.apiWebHook.privateKey = result.token;
          this.isLoadingPrivate = false;
          this.privateKey = this.hide(this.hidePrivate, this.apiWebHook.privateKey);
        } else if (result.type === 'public') {
          this.apiWebHook.publicKey = result.token;
          this.isLoadingPublic = false;
          this.publicKey = this.hide(this.hidePublic, this.apiWebHook.publicKey);
        }
      })
  }

  hide(isHide: boolean, key: string): string {
    let token = '';
    let bullet = '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022'
    if (isHide) {
      token = key.substring(0, 15)
      token = token.concat(bullet).concat(bullet).concat(bullet).concat(bullet)
    }
    else
      token = key;
    return token;
  }

  click(type: string) {
    switch (type) {
      case 'private':
        this.hidePrivate = !this.hidePrivate;
        this.privateKey = this.hide(this.hidePrivate, this.apiWebHook.privateKey);
        break;
      case 'public':
        this.hidePublic = !this.hidePublic;
        this.publicKey = this.hide(this.hidePublic, this.apiWebHook.publicKey);
        break;
      case 'newPrivate':
        this.newtoken("private");
        break;
      case 'newPublic':
        this.newtoken("public");
        break;
      default:
        console.log('error');
    }
  }

  testWebhook() {
    if (this.apiWebHook.webhook)
      parse.Cloud.run("testWebhook", {
        typeTest: this.newValueSelectTestOption
      }).then(
        res => {
          this._toastService.toastOpen(undefined, res);
          console.log(res);
        },
        error => {
          this._toastService.toastOpen(undefined, error, "error");
        }
      );
    else
      this._toastService.toastOpen(undefined, this.i18n({
        id: "invalidWebhook",
        value: "WebHook Invalide.",
        description: "WebHook Invalide.",
        meaning: "apiWebhook"
      }), "error");

  }

}



// WEBPACK FOOTER //
// ./src/app/element/parameters-apiwebhook/parameters-apiwebhook.component.ts